import { useCustomQuery, SortDirectionEnum, ActivityOption, Severity } from '@gripp/shared-logic';

const GET_PINNED_ACTIVITIES = `
  query FindIssues($filter: FindIssuesFilter, $page: PageRequest, $orderBy: OrderByInput) {
    issue {
      findIssues(filter: $filter, page: $page, orderBy: $orderBy) {
        count
        offset
        limit
        items {
          id
          severity
          title
          subtitle
          isPinned
          asset {
            name
          }
          workspace {
            name
          }
          createdAt
          adjustCreationDate
          createdBy {
            id
            name {
              first
              last
            }
          }
          updatedAt
          updatedBy {
            id
            name {
              first
              last
            }
          }
          userMentions {
            id
            name {
              first
              last
            }
          }
          latestMessage {
            text
            i18n
            createdBy {
              id
              name {
                first
                last
              }
            }
            userMentions {
              id
              name {
                first
                last
              }
            }
            reactions {
              id
              createdAt
              createdBy 
              reactionType
            }
            type
          }
        }
      }
    }
  }
`;

export const usePinnedActivities = (assetId: string) => {
  const { data, isLoading, error } = useCustomQuery({
    query: GET_PINNED_ACTIVITIES,
    variables: {
      filter: { 
        asset: { eq: assetId },
        activityOption: ActivityOption.Pinned
     },
      page: { limit: 10, offset: 0 },
      orderBy: { field: "updatedAt", order: SortDirectionEnum.Desc }
    },
    cacheKey: ['pinnedActivities', assetId],
    options: { enabled: !!assetId }
  });

  if (!assetId) {
    return {
      pinnedActivities: [],
      isLoading: false,
      error: null,
    };
  }

  const rawPinnedActivities = data?.issue?.findIssues?.items || [];

  const pinnedActivities = rawPinnedActivities.map((activity: any) => {
    return {
      id: activity.id,
      title: activity.title,
      severity: activity.severity,
    };
  });

  return {
    pinnedActivities,
    isLoading,
    error,
  };
};
